(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-collection-navigation"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = () => {
  document.querySelectorAll('.mh-visual-nav').forEach(root => {
   if (root.dataset.carouselInitialized === 'true') return;
   const track = root.querySelector('[data-category-track]');
   if (!track) return;
   root.dataset.carouselInitialized = 'true';
   const progress = root.querySelector('[data-category-progress]');
   const update = () => {
    if (!progress) return;
    const max = track.scrollWidth - track.clientWidth;
    progress.style.width = (max > 0 ? 20 + 80 * Math.max(0, Math.min(1, track.scrollLeft / max)) : 100) + '%';
   };
   const move = direction => {
    const card = track.querySelector('.mh-vnav-card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   };
   root.querySelector('.mh-exp-carousel__prev')?.addEventListener('click', () => move(-1));
   root.querySelector('.mh-exp-carousel__next')?.addEventListener('click', () => move(1));
   track.addEventListener('scroll', update, {passive:true});
   const observer = new ResizeObserver(update);
   observer.observe(track);
   const cleanup = event => {
    if (event.target.contains(root)) {
     observer.disconnect();
     document.removeEventListener('shopify:section:unload', cleanup);
    }
   };
   document.addEventListener('shopify:section:unload', cleanup);
   update();
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
 else initialize();
 document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["midnight-home-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = () => {
  document.querySelectorAll('.section-midnight-experience').forEach(root => {
   if (root.dataset.carouselInitialized === 'true') return;
   const track = root.querySelector('[data-mh-carousel-track]');
   if (!track) return;
   root.dataset.carouselInitialized = 'true';
   const progress = root.querySelector('[data-mh-carousel-progress]');
   const update = () => {
    if (!progress) return;
    const max = track.scrollWidth - track.clientWidth;
    progress.style.width = (max > 0 ? 20 + 80 * Math.max(0, Math.min(1, track.scrollLeft / max)) : 100) + '%';
   };
   const move = direction => {
    const card = track.querySelector('.mh-exp-carousel__card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   };
   root.querySelector('.mh-exp-carousel__prev')?.addEventListener('click', () => move(-1));
   root.querySelector('.mh-exp-carousel__next')?.addEventListener('click', () => move(1));
   track.addEventListener('scroll', update, {passive:true});
   const observer = new ResizeObserver(update);
   observer.observe(track);
   const cleanup = event => {
    if (event.target.contains(root)) {
     observer.disconnect();
     document.removeEventListener('shopify:section:unload', cleanup);
    }
   };
   document.addEventListener('shopify:section:unload', cleanup);
   update();
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
 else initialize();
 document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["midnight-mixed-products"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = () => {
  document.querySelectorAll('.mh-mixed-products').forEach(root => {
   if (root.dataset.carouselInitialized === 'true') return;
   const track = root.querySelector('[data-products-track]');
   if (!track) return;
   root.dataset.carouselInitialized = 'true';
   const progress = root.querySelector('[data-mh-carousel-progress]');
   const update = () => {
    if (!progress) return;
    const max = track.scrollWidth - track.clientWidth;
    progress.style.width = (max > 0 ? 20 + 80 * Math.max(0, Math.min(1, track.scrollLeft / max)) : 100) + '%';
   };
   const move = direction => {
    const card = track.querySelector('.mh-mixed-products__card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   };
   root.querySelector('[data-products-prev]')?.addEventListener('click', () => move(-1));
   root.querySelector('[data-products-next]')?.addEventListener('click', () => move(1));
   track.addEventListener('scroll', update, {passive:true});
   const observer = new ResizeObserver(update);
   observer.observe(track);
   const cleanup = event => {
    if (event.target.contains(root)) {
     observer.disconnect();
     document.removeEventListener('shopify:section:unload', cleanup);
    }
   };
   document.addEventListener('shopify:section:unload', cleanup);
   update();
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
 else initialize();
 document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
